import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Create,
  useForm,
} from "@pankod/refine-antd";
import { IParametrizations } from "interfaces";
import { ParametrizationsForm } from "components/forms";

export const ParametrizationsCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IParametrizations>();
  return (
    <Create saveButtonProps={saveButtonProps}>
      <ParametrizationsForm
        formProps={formProps}
        queryResult={queryResult}
      />
    </Create>
  );
};
